import { render, staticRenderFns } from "./NewsSearchPage.vue?vue&type=template&id=96b65280&"
import script from "./NewsSearchPage.vue?vue&type=script&lang=js&"
export * from "./NewsSearchPage.vue?vue&type=script&lang=js&"
import style0 from "./NewsSearchPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports